export default __webpack_public_path__ + "static/media/4.831e2150.jpg";